import { createElement } from "react";
import { RouteObject } from "react-router-dom";
import { JournalSectionPersonnelPage } from "@/features/journal-section-personnel";
import { routes } from "@shared/lib/react-router";
import { JournalsSectionThird } from "./ui";
import { JournalSectionFormPage } from "./ui/journal-section-form-page";
import { JournalSectionInfoPage } from "./ui/journal-section-info-page";

export const JournalsSectionThirdRoute = (
  ...rest: RouteObject[]
): RouteObject => {
  return {
    path: `${routes.journals.section3()}`,
    element: createElement(JournalsSectionThird),
    children: [
      {
        path: `form/:itemNoVersionId?`,
        element: createElement(JournalSectionFormPage),
      },
      {
        path: `view/:itemNoVersionId`,
        element: createElement(JournalSectionInfoPage),
      },
      {
        path: "personnel",
        element: createElement(JournalSectionPersonnelPage, { sectionNumber: 3 }),
      },
      ...rest,
    ],
  };
};

export const JournalsSectionThirdVersionRoute = (
  ...rest: RouteObject[]
): RouteObject => {
  return {
    path: `${routes.journals.journalVersionSection3()}`,
    element: createElement(JournalsSectionThird),
    children: [
      {
        path: `form/:itemNoVersionId?`,
        element: createElement(JournalSectionFormPage),
      },
      {
        path: `view/:itemNoVersionId`,
        element: createElement(JournalSectionInfoPage),
      },
      {
        path: "personnel",
        element: createElement(JournalSectionPersonnelPage, { sectionNumber: 3 }),
      },
      ...rest,
    ],
  };
};

